import * as React from "react";
const SvgDocumentation = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3.754 1.871v3.754H1.689v1.498l1.03.002 1.029.004.004 2.06.002 2.063H1.689v1.496l1.03.004 1.029.002v4.117l-1.03.004-1.029.002v1.498h2.065v3.752H22.127V1.871h-9.186zM5.252 3.38h15.369V20.62H5.252v-2.246h2.062v-1.498H5.252v-4.129h2.062v-1.496H5.252V7.123h2.062V5.625H5.252V4.502Zm4.117 2.246v5.252h9.006V5.625h-4.504Zm1.508 1.498 2.998.002 2.996.004.004 1.12.002 1.12h-6V8.246Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgDocumentation;
